<template>
    <div style="padding-top: 130px;">
        <hd-header></hd-header>
        <div style="display: flex;justify-content: center;align-items: center;margin-bottom: 60px;">
            <el-card style="width: 1200px;">
                <div slot="header" class="clearfix">
                    <span>实名认证</span>
                </div>
                <sub-real-name-content url="/register-realname-success"></sub-real-name-content>
                <el-form>
                    <el-form-item class="itemForm">
                        <div class="div-notice">
                            <p style="font-weight: bolder;color: #333333;margin-bottom: 10px;">认证须知</p>
                            <p>1、实名认证可以提升你在恒点MOOL的个人信息及虚拟财产的安全等级，同时也能够更好的体验恒点的各项虚拟服务；</p>
                            <p>2、我们将在你提交身份证信息后的5个工作日（不包含节假日）内完成审核，审核结果将会以短信和系统通知的形式发送给你；</p>
                            <p>3、如若账号还未绑定手机，建议你提前绑定手机；</p>
                            <p>4、实名认证审核完成后，将无法修改和删除，请谨慎填写；</p>
                            <p>5、你需要准备身份证照片（需正反两面），请确保证件照片清晰可见，严禁PS，具体可参考实名认证常见问题；</p>
                            <p>6、我们会确保你所提供的信息均处于严格的保密状态，不会泄露；</p>
                            <p>7、如存在恶意乱填写姓名，身份证号码，及上传与身份证证件无关图片者，一经发现将冻结恒点账号。</p>
                        </div>
                    </el-form-item>
                </el-form>
            </el-card>
        </div>
        <hd-footer-logined></hd-footer-logined>
    </div>
</template>

<script>
import HdHeader from '../public/Header.vue'
import HdFooterLogined from '../public/FooterLogined.vue'
import SubRealNameContent from '../public/sub/SubRealNameContent.vue'

export default {
    name: 'realname',
    components: {
        HdHeader,
        HdFooterLogined,
        SubRealNameContent
    },
    data: function () {
        return {}
    },
    methods: {}
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/register/Realname.vue